export default "__VITE_ASSET__Dc8a_a1K__"